// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"71998b63","310":"57fdd7c1","831":"aeb19e93","940":"ae13b5c6","943":"2292a0e7","992":"7532c11f"}[chunkId] + ".css";
};